// frontend/src/pages/portfolio/components/styles.ts

export const sectionReveal =
  "motion-safe:animate-slide-up motion-reduce:animate-none";

export const container = "mx-auto max-w-6xl px-4 sm:px-6 lg:px-8";

export const eyebrowClass =
  "inline-flex items-center gap-2 rounded-full border border-primary-200/80 bg-white/80 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-primary-700 shadow-xs";

export const sectionHeading =
  "font-display text-3xl font-semibold tracking-tight text-primary-950 sm:text-4xl lg:text-5xl";

export const sectionLede =
  "mt-4 max-w-2xl text-lg leading-relaxed text-gray-600 sm:text-xl";

export const cardBase =
  "rounded-2xl border border-gray-200 bg-white p-6 shadow-card ring-1 ring-primary-900/[0.04] sm:p-8";

export const cardHover =
  "motion-safe:transition-all motion-safe:hover:-translate-y-0.5 motion-safe:hover:shadow-elevated";

export const navLinkClass =
  "text-sm font-medium text-primary-700 hover:text-primary-900 transition-colors rounded-lg px-2 py-2 min-h-[44px] inline-flex items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2";

export const primaryButton =
  "btn-primary inline-flex items-center justify-center gap-2 rounded-xl px-6 py-3 text-base font-semibold min-h-[48px] focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2";

export const secondaryButton =
  "btn-secondary inline-flex items-center justify-center gap-2 rounded-xl border border-primary-200 bg-white px-6 py-3 text-base font-semibold text-primary-900 shadow-xs hover:bg-primary-50 hover:border-primary-300 transition-colors min-h-[48px] focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 touch-manipulation";
